import React from "react"
import PropTypes from "prop-types"
import ScrollIntoView from "react-scroll-into-view"

import { Section, HeaderRow, Eyebrow, Container, Title, Date, Link, NextButtonRow, NextButton } from "./styles"

const News = ({ data }) => {
  // Props
  const { news_title } = data.primary

  return (
    <Section id="news">
      <HeaderRow>
        <Eyebrow>{news_title && news_title.text}</Eyebrow>
      </HeaderRow>
      <Container>
        {data.items.map((item, i) => {
          const { news_item_title, news_item_date, news_item_link } = item
          return (
            <Link
              key={`news-article-${i}`}
              href={news_item_link && news_item_link.url}
            >
              <Date>{news_item_date}</Date>
              <Title>{news_item_title && news_item_title.text}</Title>
            </Link>
          )
        })}
      </Container>

      <NextButtonRow>
        <ScrollIntoView selector="#team">
          <NextButton>
            Team
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 5v14M5 12l7 7 7-7" />
            </svg>
          </NextButton>
        </ScrollIntoView>
      </NextButtonRow>
    </Section>
  )
}

News.propTypes = {
  data: PropTypes.object,
}

export default News
